import { h, Fragment } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { isMin736px } from '../../js/modules/utilities.js'

export const BandeAccueil = (props) => {
   useLayoutEffect(() => {
      // Force le focus sur le moteur
      focusMoteur()

      // Informe que le placeholder moteur est rendu et peut recevoir le moteur
      let event = new CustomEvent(`generateSearchZone`, {
         detail: {
            data: '',
         },
      })
      document.dispatchEvent(event)

      // Déplace le moteur selon les versions tablette/desktop
      responsiveMoteur()
   }, [])

   let { pageId, isLogged } = props
   let Component = selectComponent(pageId, isLogged)
   return (
      <Fragment>
         <h1 class="sr-only">Accueil du site Orange</h1>
         <Component {...props} />
      </Fragment>
   )
}

const selectComponent = (pageId, isLogged) => {
   let logged = isLogged ? '' : 'NL'
   let selector = pageId + logged

   switch (selector) {
      case 'hp-occasionnel':
         return OccasLogged
         break
      case 'hp-occasionnelNL':
         return OccasNotLogged
         break
      case 'hp-regulier':
         return RegulierLogged
         break
      case 'hp-regulierNL':
         return RegulierNotLogged
         break
      case 'hp-prospectNL':
         return ProspectNotLogged
   }
}

const ProspectNotLogged = ({ title, description, CTA, cacheKey }) => {
   return (
      <Fragment>
         {isMin736px() ? (
            <div class="row no-gutters mb-2 mb-xl-3 bande-top-page" data-testid="bande-top-page">
               <div class="col-12 col-lg-8 bg-gray1">
                  <div class="search-form aside-search" id="searchForm"></div>
                  <section id="carrousel"></section>
               </div>
               <div class="col-12 col-lg-4">
                  <div class="row no-gutters h-100 bg-gray2">
                     <div class="col-6 col-lg-12">
                        <div class="zone-perso zone-perso-prospect" id="zone-perso" data-testid="zone-perso" data-cache-key={cacheKey}>
                           <h2 class="title no-signature">{title}</h2>
                           <p class="intro mb-1">{description}</p>
                           <a
                              href={CTA.URL}
                              class="btn btn-secondary btn-inverse align-self-start"
                              data-oevent-category={CTA.analytics.oeventCategory}
                              data-oevent-action={CTA.analytics.oeventAction}
                              data-oevent-label={CTA.analytics.oeventLabel}
                              data-oevent-other={CTA.analytics.oeventOther}
                           >
                              {CTA.label}
                           </a>
                        </div>
                     </div>

                     <div class="col-6 col-lg-12">
                        <div class="autopromo-prospect d-flex align-items-center bg-gray2">
                           <div id="oan_ora_1_300x250_hp.prospects" class="tag-rm"></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         ) : (
            <MobileNotLogged title={title} CTA={CTA} />
         )}
      </Fragment>
   )
}

const RegulierLogged = ({ title, items, cacheKey }) => {
   return (
      <Fragment>
         {isMin736px() ? (
            <div data-testid="bande-top-page" class="bande-top-page row no-gutters mb-1">
               <div class="col-12 d-lg-none" id="init-search-form">
                  <div class="search-form aside-search" id="searchForm"></div>
               </div>
               <div class="col-sm-12 col-lg-4 order-sm-2 order-lg-1" id="zone-perso-regulier">
                  <div class="zone-perso no-gutters d-sm-flex d-lg-block row mx-lg-0" id="zone-perso" data-testid="zone-perso" data-cache-key={cacheKey}>
                     <h2 class="title no-signature mb-1 d-block col-6 col-lg-12">{title}<span class="sr-only">, accéder à vos services</span></h2>
                     <div id="search-form-wrapper"></div>
                     <div class="links-perso col-6 col-lg-12">
                        {items.map(({ icon, CTA }, index) => {
                           const analytics = CTA.analytics
                           return (
                              <div data-testid={`zone-perso-lien${index + 1}`} class="links-perso-wrapper">
                                 <a
                                    href={CTA.URL}
                                    class="links-perso-link o-link-arrow"
                                    data-pdb-zid={analytics.pdbZid}
                                    data-pdb-sc={analytics.pdbSc}
                                    data-pdb-idc={analytics.pdbIdc}
                                    data-pdb-vi={analytics.pdbVi}
                                    data-pdb-ta={analytics.pdbTa}
                                    data-adv-canal={analytics.advCanal}
                                    data-adv-cappingdata={analytics.advCappingdata}
                                    data-oevent-category={analytics.oeventCategory}
                                    data-oevent-action={analytics.oeventAction}
                                    data-oevent-label={analytics.oeventLabel}
                                    data-oevent-other={analytics.oeventOther}
                                 >
                                    <span class={`mr-1 icon ${icon}`}></span>
                                    <span class="link-text" title={CTA.label}>
                                       {CTA.label}
                                    </span>
                                 </a>
                              </div>
                           )
                        })}
                     </div>
                  </div>
               </div>
               <div class="col-sm-12 col-lg-8 order-sm-1 order-lg-2">
                  <section id="carrousel"></section>
               </div>
            </div>
         ) : (
            <MobileLogged title={title} />
         )}
      </Fragment>
   )
}

const RegulierNotLogged = ({ title, description, CTA, cacheKey }) => {
   return (
      <Fragment>
         {isMin736px() ? (
            <div data-testid="bande-top-page" class="bande-top-page row no-gutters mb-1">
               <div class="col-12 d-lg-none" id="init-search-form">
                  <div class="search-form aside-search" id="searchForm"></div>
               </div>
               <div class="col-sm-12 col-lg-4 order-sm-2 order-lg-1" id="zone-perso-regulier">
                  <div class="zone-perso no-gutters d-sm-flex d-lg-block row mx-lg-0" id="zone-perso" data-testid="zone-perso" data-cache-key={cacheKey}>
                     <div class="col-sm-0 col-lg-12 order-md-1 order-lg-1">
                        <div id="search-form-wrapper"></div>
                     </div>
                     <div class="col-sm-6 col-lg-12 order-sm-1 order-md-2">
                        <h2 class="title no-signature">{title}</h2>
                        <p class="intro mb-1 pb-0">{description}</p>
                     </div>
                     <div class="col-sm-6 col-lg-12 order-sm-2 order-md-3">
                        <a
                           href={CTA.URL}
                           class="btn btn-secondary btn-inverse align-self-start float-sm-right float-md-right float-lg-none"
                           data-oevent-category={CTA.analytics.oeventCategory}
                           data-oevent-action={CTA.analytics.oeventAction}
                           data-oevent-label={CTA.analytics.oeventLabel}
                           data-oevent-other={CTA.analytics.oeventOther}
                        >
                           {CTA.label}
                        </a>
                     </div>
                  </div>
               </div>
               <div class="col-sm-12 col-lg-8 order-sm-1 order-lg-2">
                  <section id="carrousel"></section>
               </div>
            </div>
         ) : (
            <MobileNotLogged title={title} CTA={CTA} />
         )}
      </Fragment>
   )
}

const OccasLogged = ({ title, items, cacheKey, pushText }) => {
   return (
      <Fragment>
         {isMin736px() ? (
            <Fragment>
               <div class="d-lg-none" id="init-search-form">
                  <div class="container-fluid">
                     <div class="search-form aside-search" id="searchForm"></div>
                  </div>
               </div>
               <div id="zone-perso-occasionnel" data-testid="bande-zone-perso-occasionnel" data-cache-key={cacheKey}>
                  <div class="zone-perso zone-perso-occasionnel" id="zone-perso">
                     <div class="container-fluid">
                        <div class="row">
                           <div class="col-sm-6 col-lg-12 d-flex justify-content-between">
                              <h2 class="title no-signature mb-1 d-block">{title}<span class="sr-only">, accéder à vos services</span></h2>
                              <div id="search-form-wrapper" class="mb-2"></div>
                           </div>

                           <div class="links-perso col-sm-6 col-lg-12">
                              {items.map(({ icon, CTA }, index) => {
                                 const analytics = CTA.analytics
                                 return (
                                    <div data-testid={`zone-perso-lien${index + 1}`} class="mb-1">
                                       <a
                                          href={CTA.URL}
                                          class="links-perso-link o-link-arrow"
                                          data-pdb-zid={analytics.pdbZid}
                                          data-pdb-sc={analytics.pdbSc}
                                          data-pdb-idc={analytics.pdbIdc}
                                          data-pdb-vi={analytics.pdbVi}
                                          data-pdb-ta={analytics.pdbTa}
                                          data-adv-canal={analytics.advCanal}
                                          data-adv-cappingdata={analytics.advCappingdata}
                                          data-oevent-category={analytics.oeventCategory}
                                          data-oevent-action={analytics.oeventAction}
                                          data-oevent-label={analytics.oeventLabel}
                                          data-oevent-other={analytics.oeventOther}
                                       >
                                          <span class={`mr-1 icon ${icon}`}></span>
                                          <span class="link-text" title={CTA.label}>
                                             {CTA.label}
                                          </span>
                                       </a>
                                    </div>
                                 )
                              })}
                           </div>

                           <div data-testid="zone-perso-lien4" class="push-text-perso col-12">
                              {typeof pushText === 'object' && !Array.isArray(pushText) && pushText !== null ? (
                                 <div class={`push-text-wrapper message-type${pushText.textType}`}>
                                    <a
                                       href={pushText.CTA.URL}
                                       class="links-perso-link o-link-arrow"
                                       data-pdb-zid={pushText.CTA.analytics.pdbZid}
                                       data-pdb-sc={pushText.CTA.analytics.pdbSc}
                                       data-pdb-idc={pushText.CTA.analytics.pdbIdc}
                                       data-pdb-vi={pushText.CTA.analytics.pdbVi}
                                       data-pdb-ta={pushText.CTA.analytics.pdbTa}
                                       data-adv-canal={pushText.CTA.analytics.advCanal}
                                       data-adv-cappingdata={pushText.CTA.analytics.advCappingdata}
                                       data-oevent-category={pushText.CTA.analytics.oeventCategory}
                                       data-oevent-action={pushText.CTA.analytics.oeventAction}
                                       data-oevent-label={pushText.CTA.analytics.oeventLabel}
                                       data-oevent-other={pushText.CTA.analytics.oeventOther}
                                    >
                                       <span class={`mr-1 icon ${pushText.icon}`}></span>
                                       <span class="link-text" title={pushText.CTA.label}>
                                          {pushText.CTA.label}
                                       </span>
                                    </a>
                                 </div>
                              ) : (
                                 <div class="pushTextPlaceholder"></div>
                              )}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Fragment>
         ) : (
            <MobileLogged title={title} />
         )}
      </Fragment>
   )
}

const OccasNotLogged = ({ title, description, CTA, cacheKey }) => {
   return (
      <Fragment>
         {isMin736px() ? (
            <Fragment>
               <div class="d-lg-none" id="init-search-form">
                  <div class="container-fluid">
                     <div class="search-form aside-search" id="searchForm"></div>
                  </div>
               </div>

               <div id="zone-perso-occasionnel" data-testid="bande-zone-perso-occasionnel" data-cache-key={cacheKey}>
                  <div class="zone-perso zone-perso-occasionnel" id="zone-perso">
                     <div class="container-fluid">
                        <div class="row">
                           <div class="col-sm-6 col-lg-4">
                              <h2 class="title no-signature d-block">{title}</h2>
                              <p class="intro pb-0">{description}</p>
                           </div>

                           <div class="col-sm-6 col-lg-4 d-flex flex-column justify-content-md-start justify-content-lg-center align-items-md-end align-items-lg-start">
                              <a
                                 href={CTA.URL}
                                 class="btn btn-secondary btn-inverse"
                                 data-oevent-category={CTA.analytics.oeventCategory}
                                 data-oevent-action={CTA.analytics.oeventAction}
                                 data-oevent-label={CTA.analytics.oeventLabel}
                                 data-oevent-other={CTA.analytics.oeventOther}
                              >
                                 {CTA.label}
                              </a>
                           </div>

                           <div id="search-form-wrapper" class="col-4"></div>
                        </div>
                     </div>
                  </div>
               </div>
            </Fragment>
         ) : (
            <MobileNotLogged title={title} CTA={CTA} />
         )}
      </Fragment>
   )
}

const MobileLogged = ({ title }) => {
   return (
      <Fragment>
         <div class="container-fluid">
            <div class="row">
               <div class="col-12" data-testid="bande-zone-perso-client">
                  <div class="d-flex align-items-center zone-perso">
                     <h2 class="h3 mb-0 no-signature">{title}<span class="sr-only">, accéder à vos services</span></h2>
                  </div>
               </div>
            </div>
         </div>
         <section id="carrousel"></section>
      </Fragment>
   )
}

const MobileNotLogged = ({ title, CTA }) => {
   return (
      <Fragment>
         <div class="container-fluid">
            <div class="row">
               <div class="col-12" data-testid="bande-zone-perso-nl">
                  <div class="d-flex justify-content-between align-items-center zone-perso">
                     <h2 class="h3 mb-0 no-signature">{title}</h2>
                     <div class="text-right">
                        <a
                           href={CTA.URL}
                           class="o-link-arrow font-weight-normal"
                           data-oevent-category={CTA.analytics.oeventCategory}
                           data-oevent-action={CTA.analytics.oeventAction}
                           data-oevent-label={CTA.analytics.oeventLabel}
                           data-oevent-other={CTA.analytics.oeventOther}
                        >
                           {CTA.label}
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <section id="carrousel"></section>
      </Fragment>
   )
}

// Focus sur le input search
// On met en place un observer qui detect lorsque le moteur est
// injecté dans notre div#searchForm et on applique le focus et
// les evenements dessus
const focusMoteur = () => {
   const togglePlaceholder = () => {
      let searchInputHp = document.querySelector('#o-search-input-hp')
      let searchLabelHp = document.querySelector('.o-search-label')
      if (searchInputHp.value !== '') {
         searchLabelHp.style.opacity = 0
         searchLabelHp.style.cssText = 'display:none !important'
      } else {
         searchLabelHp.style.opacity = 1
         searchLabelHp.style.cssText = 'display:block !important'
      }
   }

   const callback = () => {
      let searchInputHp = document.querySelector('#o-search-input-hp')
      searchInputHp.addEventListener('input', togglePlaceholder, false)
      searchInputHp.addEventListener('change', togglePlaceholder, false)
      searchInputHp.addEventListener('keydown', togglePlaceholder, false)
      searchInputHp.addEventListener('focus', togglePlaceholder, false)
      window.setTimeout(() => searchInputHp.focus(), 0) // https://stackoverflow.com/questions/1096436/document-getelementbyidid-focus-is-not-working-for-firefox-or-chrome
      searchFocusObserver.disconnect()
   }

   // Mise en place de l'observer
   var searchFocusObserver = new MutationObserver(callback)
   var options = { subtree: true, childList: true }
   var searchContainer = document.querySelector('#searchForm')

   if (searchContainer !== null) {
      searchFocusObserver.observe(searchContainer, options)
   }
}

// Responsive du input search
const responsiveMoteur = () => {
   try {
      if (window.matchMedia) {
         const mq = window.matchMedia('(min-width: 960px)')
         mq.addListener(WidthChange)
         WidthChange(mq)
      }
   } catch (error) {
      console.error('SearchForm orchestrator : ', error)
   }

   function WidthChange(mq) {
      let searchFocus = document.getElementById('o-search-input-hp')
      if (mq.matches) {
         // search form
         let nodeSearch = document.querySelectorAll('#init-search-form #searchForm')[0]
         if (nodeSearch) {
            nodeSearch.parentNode.removeChild(nodeSearch)
            document.getElementById('search-form-wrapper').appendChild(nodeSearch)
            document.querySelectorAll('#search-form-wrapper')[0].classList.add('mb-1')
         }
      } else {
         // search form
         let nodeSearch = document.querySelectorAll(' #search-form-wrapper #searchForm')[0]
         if (nodeSearch) {
            nodeSearch.parentNode.removeChild(nodeSearch)
            document.getElementById('init-search-form').appendChild(nodeSearch)
            document.querySelectorAll('#search-form-wrapper')[0].classList.remove('mb-1')
         }
      }
      if (searchFocus === document.activeElement) {
         searchFocus.focus()
      }
   }
}
